import YandexGoals from 'www/modules/YandexGoals'

new YandexGoals({
  dataName: 'data-analyzes-yandex-goals',
})
